import {createCachedSelector} from 're-reselect'
import {selectCombinedInputFieldStatusBySectionName} from '../../../modules/input-fields'
import {aInitializeDynamicNavigationItems, selectNavigationItemsArePending} from './dynamic'
import {selectStaticNavigationSubSections} from './static'

export const selectNavigationItems = createCachedSelector(
  selectStaticNavigationSubSections,
  staticSubSections => staticSubSections
)((state, externalCompanyId, sectionName) => sectionName ?? 'DEbUG')

export const selectNavigationItemStatus = selectCombinedInputFieldStatusBySectionName

export const selectNavigationTarget = createCachedSelector(selectNavigationItems, items => {
  if (items.length > 0) {
    return items[0]
  }
  return null
})((state, sectionName) => sectionName)

export const selectNavigationTargetIsLoading = selectNavigationItemsArePending

export const aInitializeNavigationTargets = aInitializeDynamicNavigationItems
